import { render } from "./DeleteEnvelopeModal.vue?vue&type=template&id=c689abdc&scoped=true&ts=true"
import script from "./DeleteEnvelopeModal.vue?vue&type=script&lang=ts"
export * from "./DeleteEnvelopeModal.vue?vue&type=script&lang=ts"

import "./DeleteEnvelopeModal.vue?vue&type=style&index=0&id=c689abdc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c689abdc"]])

export default __exports__